import { CounterLpVault, formatCompact, type EnrichedMarket } from "@axiome/counter-lp-sdk";
import { ProvidePanel } from "./ProvidePanel";

export function PoolDetail(props: {
  market: EnrichedMarket;
  vault: CounterLpVault;
  account: string | null;
  requirePreview?: boolean;
  onBack: () => void;
  onProvide: (axm: string) => Promise<void>;
  onConnect: () => void;
}) {
  const m = props.market;
  const initial = m.symbol.slice(0, 2);

  return (
    <div className="pool-detail">
      <button type="button" className="back-btn" onClick={props.onBack}>
        ← К списку пар
      </button>

      <div className="pool-detail-hero">
        <div className="token-avatar lg">
          {m.tokenLogo ? <img src={m.tokenLogo} alt={m.symbol} /> : initial}
        </div>
        <h1 className="pool-detail-title">
          {m.symbol}
          <span> / AXM</span>
        </h1>
        <p className="pool-detail-sub">{m.tokenName}</p>
        <div className="pool-detail-apr">
          <strong>{m.effectiveApr.toFixed(2)}%</strong>
          <span>ваша доходность · пул {m.apr.toFixed(2)}%</span>
        </div>
      </div>

      <div className="pool-metrics detail">
        <div>
          <span>Ликвидность</span>
          <b>{formatCompact(m.tvlAxm)} AXM</b>
        </div>
        <div>
          <span>Объём 24ч</span>
          <b>{formatCompact(m.vol24Axm)}</b>
        </div>
        <div>
          <span>Комиссия</span>
          <b>{m.poolFeePercent}%</b>
        </div>
        <div>
          <span>Цена</span>
          <b>{formatCompact(m.priceTokenInAxm, 4)} AXM</b>
        </div>
        <div>
          <span>В пуле AXM</span>
          <b>{formatCompact(Number(m.reserveAxm) / 1e6)}</b>
        </div>
        <div>
          <span>В пуле {m.symbol}</span>
          <b>{formatCompact(Number(m.reserveToken) / 10 ** m.tokenDecimals)}</b>
        </div>
      </div>

      {!props.account ? (
        <div className="provide-box" style={{ marginTop: 14 }}>
          <p className="lead" style={{ margin: 0 }}>
            Подключите кошелёк, чтобы внести ликвидность только в AXM.
          </p>
          <div className="cta-row">
            <button className="btn btn-primary" onClick={props.onConnect}>
              Подключить кошелёк
            </button>
          </div>
        </div>
      ) : null}

      <ProvidePanel
        vault={props.vault}
        market={m}
        account={props.account}
        requirePreview={props.requirePreview}
        onProvide={props.onProvide}
      />
    </div>
  );
}
